import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { GetAvailableRoutesByRole } from "../../services/apiService";
import { setAllowedRoutes } from "../../redux/slices/userSlice";

const useAuth = () => {
  const { accounts, instance } = useMsal();
  const account = accounts[0];
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state?.user?.userData);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const validateSession = async () => {
      try {
        if (isAuthenticated) {
          setError(null);
          setIsLoading(false);
          return;
        }

        if (!account) {
          setError("No active session");
          return;
        }

        /*
        const expirationTime = account.idTokenClaims?.exp * 1000;
        if (!expirationTime || Date.now() >= expirationTime) {
          setError("Session expired");
          await instance.logoutRedirect();
          return;
        }
        */
        try {
          console.log("account", account);
          const role = account.idTokenClaims?.roles?.[0];
          console.log("role", role);
          const responseRoles = await GetAvailableRoutesByRole(role);
          const routes = responseRoles.data;
          dispatch(setAllowedRoutes(routes));
        } catch (routeError) {
          console.error("Error fetching routes");
        }

        setError(null);
      } catch (err) {
        setError("Authentication error");
        console.error("Auth validation error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    validateSession();
  }, [account, isAuthenticated, instance, dispatch]);

  return { isLoading, error, isAuthenticated: !error || isAuthenticated };
};

const ProtectedRoute = ({ children }) => {
  const { isLoading, error, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
